class Kosar {

    constructor() {

        this.kiszerelesek = [
            'kiszereles_100_db',
            'kiszereles_170_db',
            'kiszereles_250_db',
            'kiszereles_500_db',
            'kiszereles_2500_db',
            'kiszereles_375_db',
            'kiszereles_330_db',
            'kiszereles_200_db',
            'kiszereles_2500_db',

            'kiszereles_50g_db',
            'kiszereles_60g_db',
            'kiszereles_90g_db',
            'kiszereles_70g_db',
            'kiszereles_100g_db',
            'kiszereles_120g_db',
            'kiszereles_140g_db',
            'kiszereles_130g_db',
            'kiszereles_150g_db',
            'kiszereles_200g_db',
            'kiszereles_210g_db',
            'kiszereles_250g_db',
            'kiszereles_260g_db',
            'kiszereles_300g_db',
            'kiszereles_500g_db',

            'kiszereles_db_db',
            'kiszereles_075l_db',
            'kiszereles_3l_db'
        ],

        this.itemtotal = 0;

        this.localStorageCartData = {};

        this.kosarFelugro = false;
    }

    showSelectdialog(datas)
    {

        // if (window.location.href.indexOf('ujfelugro') != -1)
        if (
            $("html").data('locale') == 'hu_HU'
            || $("html").data('locale') == 'de_DE'
            || $("html").data('locale') == 'sl_SI'
            || $("html").data('locale') == 'en_US'
            || $("html").data('locale') == 'fr_BE'
            || $("html").data('locale') == 'fr_FR'
            || $("html").data('locale') == 'cs_CZ'
            || (window.location.href.indexOf('design2024') != -1 && $("html").data('locale') == 'en_US')
            || (window.location.href.indexOf('design2024') != -1 && $("html").data('locale') == 'en_AU')
            || window.location.href.indexOf('ujfelugro') != -1
        )
        {
            this.showSidePanel();
        } else {

            if (this.kosarFelugro && window.innerWidth > 998)
            {

                $('<div>').addClass('termekadatlap-felugro-kont-layer hidden-xs smalldesign').appendTo('body');
                var kfk = $('<div>').addClass('termekadatlap-felugro-kont hidden-xs row smalldesign');
                $('<div>').addClass('wait-datas').appendTo(kfk);
                $('<a>').attr('href', '#').addClass('closeme top').appendTo(kfk);
                kfk.appendTo('body');
                $('a.closeme').on('click', function(e){e.preventDefault(); Kosar.closeSelectDialog();});

                setTimeout(function(){
                    $('.termekadatlap-felugro-kont-layer, .termekadatlap-felugro-kont').addClass('showme');

                }, 10);

                this.loadSelectdialog(datas);
            }
        }
    }

    loadSelectdialog(datas)
    {
        $.get('/index.php/termekadatlap/felugro', datas, function(res){

            $('.termekadatlap-felugro-kont .wait-datas').remove();
            $('.termekadatlap-felugro-kont').append(res);

            setTimeout(function(){

                $('.megtakaritas .megtakaritas-value').prop('Counter', 0).animate({
                    Counter: +$('.megtakaritas .megtakaritas-value').attr('data-target-value')
                }, {
                    duration: 1000,
                    easing: 'swing',
                    step: function (now) {
                        var resNum = Math.ceil(now);
                        if ($("html").data('locale') != 'hu_HU')
                        {
                            resNum = Math.round(now * 100) / 100;
                        }
                        $(this).find('span').text(resNum);
                    }
                });


                $('.termekadatlap-felugro .ajanlo-carousel').slick({
                    slideToShow: 1,
                    slideToScroll: 1,
                    variableWidth: false,
                    prevArrow: '<span class="podor-arrow-left"></span>',
                    nextArrow: '<span class="podor-arrow-right"></span>',
                    responsive: [
                        {
                            breakpoint: 800,
                            settings: {
                                arrows:false
                            }
                        }
                    ]
                });

                initFancySelect();

            }, 800);


            $('.termekadatlap-felugro .closeme').on('click', function(e){e.preventDefault(); Kosar.closeSelectDialog();});



        }, 'html');
    }

    loadIngyenlimit (datas)
    {
        datas["ingyenlimit_view"] = 1;
        $.get('/index.php/termekadatlap/felugro', datas, function(res){

            $('.termekadatlap-felugro-kont .topmessage strong').text(datas.res.kos.allproduct);

            $('.termekadatlap-felugro-kont .gratis-kont .gratis-progress').append(res);

            setTimeout(function(){
                $('.ko-progress-circle').attr('data-progress', $('.ko-progress-circle').attr('data-progress-target'));

                $('.ko-progress-circle .aktvalue').prop('Counter', +$('.ko-progress-circle .aktvalue').attr('data-target-max-value')).animate({
                    Counter: +$('.ko-progress-circle .aktvalue').attr('data-target-value')
                }, {
                    duration: 1000,
                    easing: 'swing',
                    step: function (now) {
                        var resNum = Math.ceil(now);
                        if ($("html").data('locale') != 'hu_HU')
                        {
                            resNum = Math.round(now * 100) / 100;
                        }
                        $(this).find('span').text(resNum);
                        if (resNum == 0)
                        {
                            $('.ko-progress-circle').addClass('zero-reached');
                        }
                    }
                });

            }, 800);

        }, 'html');
    }

    closeSelectDialog ()
    {
        $('.termekadatlap-felugro-kont-layer, .termekadatlap-felugro-kont').addClass('remove');
        $('.termekadatlap-felugro-kont').removeClass('showme');
        setTimeout(function(){
            $('.termekadatlap-felugro-kont-layer, .termekadatlap-felugro-kont').remove();
        }, 1000);
    }

    saveKosarToBrowser(thenReload) {

        if (!thenReload) {
            var thenReload = false;
            }
        $.get('/index.php/webshop/getsessionkosaritems', (res) => {
            if (res != '') {
                var savedData = res['kosaritems'];
                Kosar.localStorageCartData = savedData;
                this.updateLocalStorageCartData(savedData);
                $.post('/index.php/webshop/setsessionkosaritems', { items: Kosar.localStorageCartData }, function () {
                    if (thenReload) {
                        window.location.reload();
                    } else {
                        // Kosar.updateKosarNumbers();
                    }
                });
            }
        });

    }

    updateKosarFromBrowser() {
        $.post('/index.php/webshop/setsessionkosaritems', { items: Kosar.localStorageCartData });
    }

    loadBrowserSavedKosar() {

        if (window.localStorage) {
            var savedData = localStorage.getItem('cartData');
            if (savedData != null) {
                Kosar.localStorageCartData = JSON.parse(savedData);
                // update cart number in the header
                try {
                    if (Kosar.localStorageCartData.length > 0) {
                        Kosar.updateKosarNumbers();
                        Kosar.updateKosarFromBrowser();
                        if ($('body').hasClass('loggeduser')) {
                            Kosar.saveKosarToBrowser();
                            Kosar.updateKosarNumbers();
                        }
                    }
                } catch (e) {
                }

            }
        }
    }

    updateLocalStorageCartData(savedData) {
        if (window.localStorage) {
            localStorage.setItem('cartData', JSON.stringify(savedData));
        }
    }

    clearSavedKosar() {
        if (window.localStorage) {
            localStorage.removeItem('cartData');
        }
    }

    updateKosarNumbers()
    {
        var itemtotal = 0;
        try {
            for (var i = 0; i < Kosar.localStorageCartData.length; i++) {
                itemtotal += +Kosar.localStorageCartData[i].db;
            }
        } catch (e) {
        }
        $('#kosarlink1 .amount, #kosarlink2 .amount, .header .tools .shop .amount').each(function(){
            $(this).text(itemtotal);
            if (+itemtotal > 9)
            {
                $(this).addClass('wider');
            }
        });
        $('.webshop-button-d2 .cart-num').text(itemtotal);
    }

    showSidePanel()
    {

        var validShow = true;

        if ($('body').hasClass('loggeduser'))
        {
            if ($('body').hasClass('loggedloconuser') || $('body').hasClass('loggedprimeuser'))
            {
                validShow = false;
            }
        }

        if (window.innerWidth < 998)
        {
            validShow = false;
        }

        if (
            $("html").data('locale') != 'hu_HU'
            && $("html").data('locale') != 'sl_SI'
            && $("html").data('locale') != 'en_US'
            && $("html").data('locale') != 'fr_FR'
            && $("html").data('locale') != 'fr_BE'
            && $("html").data('locale') != 'de_DE'
            && $("html").data('locale') != 'cs_CZ'
        )
        {
            validShow = false;
        }

        if (
            (window.location.href.indexOf('design2024') != -1 && $("html").data('locale') == 'en_AU')
            || (window.location.href.indexOf('design2024') != -1 && $("html").data('locale') == 'en_US')
        ) {
            validShow = true;
        }

        if (!validShow)
        {
            return false;
        }

        var datas = {};

        datas["t"] = new Date().getTime();

        $.get('/index.php/termekadatlap/sidepanel', datas, (res)  => {

            if ($('.kosar-panel-kont-layer, .kosar-panel-kont').length > 0)
            {
                return false;
            }

            $('<div>').addClass('kosar-panel-kont-layer pms-overlay').appendTo('body');

            $('body').append(res);

            setTimeout(function(){
                $('.kosar-panel-kont').addClass('opened');
            }, 100);

            this.sidePanelPercentAnime();


            $('.kosar-panel-kont .closeme, .kosar-panel-kont-layer').on('click', (e) => { e.preventDefault(); this.closeSidePanel(); });

            this.sidePanelAtmeretezes();

            setTimeout(() =>{
                General.loadKosarpanelTermekLegkedveltebbCarouselData();
            }, 500);

        });
    }

    closeSidePanel()
    {
        $('.kosar-panel-kont-layer, .kosar-panel-kont').removeClass('opened');
        setTimeout(function(){
            $('.kosar-panel-kont-layer, .kosar-panel-kont').remove();
        }, 300);
    }

    sidePanelPercentAnime()
    {
        setTimeout(function () {
            var perc = $('.kosar-panel-kont .free-delivery-progress .progressbar span').data('percent');
            // $('.kosar-panel-kont .free-delivery-progress .progressbar span:not(.maximized)').css('width', 'calc(' +perc + '% - 25px)');
            $('.kosar-panel-kont .free-delivery-progress .progressbar span:not(.maximized)').css('width', +perc + '%');

            if ($('.kosar-panel-kont .free-delivery-progress').hasClass('max-reached'))
            {
                $('.kosar-panel-kont .free-delivery-progress .maximized').addClass('popit');
            }
        }, 500);
    }

    sidePanelAtmeretezes()
    {
        if ($('.kosar-panel-kont').length > 0) {

            var fullPanelHeight = $('.kosar-panel-kont').height();
            var termeklistKontHeight = $('.kosar-panel-body').height();
            var termekListHeight = $('.kosar-items-kont').height();

            if ($(window).height() < 750) {
                $('.kosar-panel-kont .kosar-panel-footer .kosar-carousel').css('display', 'none');
            } else {
                $('.kosar-panel-kont .kosar-panel-footer .kosar-carousel').css('display', 'block');
            }

            var footerHeight = $('.kosar-panel-footer').height();
            var termekListNewHeight = fullPanelHeight - footerHeight - (termeklistKontHeight - termekListHeight);

            $('.kosar-items-kont').css('maxHeight', termekListNewHeight + 'px');

        }
    }


    ad()
    {
        var datas = {}, maxNum = 0;

        datas['termek_id'] = $('input[name=termek_id]').val();
        datas['akt_termek_ar'] = $('[name="akt_termek_ar"]').val();
        datas['akt_termek_klub_ar'] = $('[name="akt_termek_klub_ar"]').val();
        datas['actcurrency'] = $('[name="actcurrency"]').val();
        datas['termek_data'] = {
            'kep': termekDirectData.felugro_kep,
            'nev': termekDirectData.felugro_nev
        };

        if (kozmetikaDesign)
        {
            datas["kozmetika"] = 1;
        }

        datas['sessdata'] = typeof shopSessData == 'undefined' ? '' : shopSessData;

        // datas['debug'] = 1;

        if ($(".cart-box select[name^=adatlap_kiszereles_]").length > 0)
        {
            $('.cart-box select[name^=adatlap_kiszereles_]').each(function(i, selo){
                if ($(selo).val() > 0)
                {
                    datas['type_'+(i+1)] = $(selo).attr('name').replace(/adatlap_kiszereles_(.+)_db/, '$1');
                    datas['db_'+(i+1)] = $(selo).val();
                    maxNum += $(selo).val();
                }
            });
        } else {

            $('.cart-box select[name^=kiszereles_]').each(function(i, selo){
                if ($(selo).val() > 0)
                {
                    datas['type_'+(i+1)] = $(selo).attr('name').replace(/kiszereles_(.+)_db/, '$1');
                    datas['db_'+(i+1)] = $(selo).val();
                    maxNum += $(selo).val();
                }
            });
        }


        if (window.location.href.indexOf('navi4') != -1)
        {
            datas["upsalev2"] = 1;
        }

        var cart = $('.webshop-button-d2');


        if (maxNum > 0) {


            $('.product-details .cart .cart-box  .fancy-select-display .text:first').each(function (i, elo) {

                var self = $(elo);
                var imgclone = self.clone()
                    .addClass('shrink')
                    .offset({top: self.offset().top, left: self.offset().left})
                    .css({'opacity': '0.5', 'position': 'absolute', 'overflow': 'hidden', 'z-index': '1000'})
                    .appendTo($('body'));
                imgclone.animate({
                    // 'width':0,
                    // 'height':0,
                    'top': cart.offset().top + 10,
                    'left': cart.offset().left + 30
                }, 500, 'swing', function () {
                    $(this).detach();
                    $('.webshop-button-d2').addClass('changed');


                    (function(datas){

                        if (typeof GTAGDataItem != "undefined" )
                        {
                            GTMDataPusher.listItemAddToCart(GTAGDataItem, 1);
                            GtagDataPusher.listItemAddToCart(GTAGDataItem, 1);
                        }

                        $.post('/kosar/ad', datas, function (res) {

                            $('.webshop-button-d2 .cart-num').text(res.kos.allproduct);

                            //$('.header .tools .shop .amount').text(res.kos.allproduct);
                            $('#kosarlink1 .amount, #kosarlink2 .amount, .header .tools .shop .amount').each(function(){
                                $(this).text(res.kos.allproduct);
                                if (+res.kos.allproduct > 9)
                                {
                                    $(this).addClass('wider');
                                }
                            });

                            var value = '', value_klub = '', curr = $('[name=actcurrency]').val();

                            if ($("html").data('locale') == 'en_US' || $("html").data('locale') == 'en_UK' || $("html").data('locale') == 'en_AU') {
                                value = curr + ' 0';
                                value_klub = curr + ' 0';

                            } else if ($("html").data('locale') == 'hu_HU') {
                                value = '0 ' + curr;
                                value_klub = '0 ' + curr;
                            } else {
                                value = '0 ' + curr;
                                value_klub = '0 ' + curr;
                            }

                            $("span#kosarbanosszesen").text(value);
                            if ($("span#kosarbanosszesen_klubar").length > 0)
                            {
                                $("span#kosarbanosszesen_klubar").text(value_klub);
                            }

                            $('.cart-box select[name*=kiszereles_]').each(function (i, selo) {
                                $(selo).val('0').trigger('change');
                            });

                            $('#kosarlink1, #kosarlink2, #kosarlink3').attr('href', kosarShopURL);

                            //datas['res'] = res;
                            datas['posta_ingyenlimit'] = $('[name="posta_ingyenlimit"]').val() != "" ? $('[name="posta_ingyenlimit"]').val() : postaIngyenlimit;
                            datas['actcurrency'] = $('[name="actcurrency"]').val();

                            //window.location.reload()
                            //Kosar.loadIngyenlimit(datas);
                            Kosar.saveKosarToBrowser();
                        });
                    })(datas);

                    setTimeout(function () {
                        $('.webshop-button-d2').removeClass('changed');

                        Kosar.showSelectdialog(datas);

                    }, 1100);


                });
            });
        } else {
            $('.product-details .cart .cart-box  .fancy-select-kont').each(function(i, selo){

                $(selo).addClass('shake-shake');
                setTimeout(function(){
                    $(selo).removeClass('shake-shake');
                }, 1100);
            });
        }

        return false;
    }

    init()
    {
        if ($("[name^='kiszereles_']").length > 0)
        {
            $("[name^='kiszereles_']").each(function(i, kise){
                $(kise).change(function(){
                    Kosar.updateosszeg();
                });
            });
        }


        if ($("[name^='adatlap_kiszereles_']").length > 0)
        {
            $("[name^='adatlap_kiszereles_']").each(function(i, kise){
                $(kise).change(function(){
                    Kosar.adatlap_updateosszeg(this);
                });
            });
        }

        // kosár törlés linkre esemény rakása
        if ($('.kosar-torles-kont').length > 0)
        {

            $('.kosar-torles-kont a').on('click', (e) => {
                e.preventDefault();
                $.get('/index.php/webshop/clearall', () => {
                    //    this.saveKosarToBrowser(true);
                    window.location.reload();
                });
            });
        }

    }

    adatlap_updateosszeg(sel)
    {

        var
            curr = $('[name=actcurrency]').val(),
            afa = $('[name=afa_szazalek]').val(),
            ar_db = +$(sel).data('ar'),
            ar_brutto_db = +$(sel).data('ar_brutto'),
            klubar_db = +$(sel).data('klubar'),
            seldb = +$(sel).val(),
            full_ar_obj = JSON.parse(decodeURIComponent($(sel).data('full_ar'))),
            ar_ceges_netto_db = +$(sel).data('ar_brutto');


        ar_ceges_netto_db = +full_ar_obj.price_nagyker_ceges_ar;

        if (seldb == 0)
        {
            seldb = 1;
        }

        if (ar_db == 0 || klubar_db == 0)
        {

        }

        var
            webshopar = ar_db * seldb,
            webshopar_brutto = ar_brutto_db * seldb,
            ceges_netto = ar_ceges_netto_db * seldb,
            klubar = klubar_db * seldb,
            kedv = webshopar - klubar,
            webshopar_text = "",
            webshopar_brutto_text = "",
            ceges_netto_text = "",
            klubar_text = "",
            kedv_text = "";

        // console.log(klubar, kedv)
        // console.log(full_ar_obj)

        if ($("html").data('locale') == 'en_US' || $("html").data('locale') == 'en_UK' || $("html").data('locale') == 'en_AU')
        {
            kedv_text = curr + this.number_format(kedv, 2,".",",");
            webshopar_text = curr + this.number_format(webshopar, 2,".",",");
            klubar_text = curr + this.number_format(klubar, 2,".",",");

        } else if ($("html").data('locale') == 'hu_HU') {
            curr = "Ft";
            kedv_text = this.number_format(kedv, 0,"."," ") + " " + curr;
            webshopar_text = this.number_format(webshopar, 0,"."," ") + " " + curr;
            klubar_text = this.number_format(klubar, 0,"."," ") + " " + curr;
            webshopar_brutto_text = this.number_format(webshopar_brutto, 0,"."," ") + " " + curr;
            ceges_netto_text = this.number_format(ceges_netto, 0,"."," ") + " " + curr;
        } else {
            /*
            kedv_text = curr + this.number_format(kedv, 2,",",".");
            webshopar_text = curr + this.number_format(webshopar, 2,",",".");
            klubar_text = curr + this.number_format(klubar, 2,",",".");
             */
            kedv_text = this.number_format(kedv, 2,",",".") + " " + curr;
            webshopar_text = this.number_format(webshopar, 2,",",".") + " " + curr;
            webshopar_brutto_text = this.number_format(webshopar_brutto, 2,",",".") + " " + curr;
            ceges_netto_text = this.number_format(ceges_netto, 2,",",".") + " " + curr;
            klubar_text = this.number_format(klubar, 2,",",".") + " " + curr;
        }


        if (kedv > 0)
        {
            $(sel).parents('.size-row').find('.kedvezmeny-text').text(kedv_text);
            $(sel).parents('.size-row').find('.webshop-ar-head.kedvezmeny').css('visibility', 'visible');
            $(sel).parents('.size-row').find('.webshop-ar-col.kedvezmeny').css('visibility', 'visible');
        } else {
            $(sel).parents('.size-row').find('.webshop-ar-head.kedvezmeny').css('visibility', 'hidden');
            $(sel).parents('.size-row').find('.webshop-ar-col.kedvezmeny').css('visibility', 'hidden');
        }

        $(sel).parents('.size-row').find('.webshopar-text').text(webshopar_text);
        if (webshopar_brutto > 0)
        {
            $(sel).parents('.size-row').find('.webshopar-text-brutto').text(webshopar_brutto_text);
        }
        if (ceges_netto > 0)
        {
            $(sel).parents('.size-row').find('.ceges-ar-text-netto').text(ceges_netto_text);
        }
        $(sel).parents('.size-row').find('.klubar-text').text(klubar_text);


        if (shopLoginStatusFirm)
        {
            if (full_ar_obj.akcio_aktiv == 1)
            {
                /*
                if (shopLoginStatusFirm)
                {
                    var akcio_value = +full_ar_obj.price_nagyker_ar * seldb,
                        akcio_nagyker_kedvezmeny = Math.abs(klubar - akcio_value),
                        webshop_netto_ar = +full_ar_obj.price_webshop_netto_ar * seldb;
                    ;
                } else {

                    var akcio_value = +full_ar_obj.price_nagyker_ar_locon * seldb,
                        akcio_nagyker_kedvezmeny = Math.abs(klubar - akcio_value),
                        webshop_netto_ar = +full_ar_obj.price_webshop_netto_ar * seldb;
                    ;
                }*/

                var akcio_value = +full_ar_obj.price_nagyker_ar * seldb,
                    akcio_value_ceges = +full_ar_obj.price_webshop_ar * seldb,
                    akcio_nagyker_kedvezmeny = Math.abs(klubar - akcio_value),
                    akcio_ceges_kedvezmeny = Math.abs(klubar - akcio_value_ceges),
                    webshop_netto_ar = +full_ar_obj.price_webshop_netto_ar * seldb
                ;

                if (shopLoginStatusLoc)
                {
                    // akcio_value = +full_ar_obj.price_nagyker_ar_locon * seldb;
                    // akcio_nagyker_kedvezmeny = Math.abs(klubar - akcio_value);
                    // webshop_netto_ar = +full_ar_obj.price_webshop_netto_ar * seldb;
                }

                var akcio_nagyker_kedvezmeny_text = this.number_format(akcio_nagyker_kedvezmeny, 2,",",".") + " " + curr;
                var akcio_value_text = this.number_format(akcio_value, 2,",",".") + " " + curr;
                var webshop_netto_ar_text = this.number_format(webshop_netto_ar, 2,",",".") + " " + curr;


                if ($("html").data('locale') == 'hu_HU')
                {
                    akcio_nagyker_kedvezmeny_text = this.number_format(akcio_nagyker_kedvezmeny, 0,"."," ") + " " + curr;
                    akcio_value_text = this.number_format(akcio_value, 0,"."," ") + " " + curr;
                    webshop_netto_ar_text = this.number_format(webshop_netto_ar, 0,"."," ") + " " + curr;
                }


                if (shopLoginStatusLocCsok)
                {
                    if ($("html").data('locale') == 'hu_HU')
                    {
                        akcio_nagyker_kedvezmeny_text = this.number_format(akcio_ceges_kedvezmeny, 0,"."," ") + " " + curr;
                    } else {
                        akcio_nagyker_kedvezmeny_text = this.number_format(akcio_ceges_kedvezmeny, 2,",",".") + " " + curr;
                    }
                }

                $(sel).parents('.size-row').find('.webshopar-text.locon-akcio').text(akcio_value_text);
                $(sel).parents('.size-row').find('.kedvezmeny-text.locon-akcio-kedvezmeny-value').text(akcio_nagyker_kedvezmeny_text);
                $(sel).parents('.size-row').find('.klubar-text').text(klubar_text);
                $(sel).parents('.size-row').find('.webshopar-text-netto').text(webshop_netto_ar_text);

            }

        }


    }

    updateosszeg()
    {
        var total = 0, klub_total = 0, curr = $('[name=actcurrency]').val(), afa = $('[name=afa_szazalek]').val();

        /*
        $.each(this.kiszerelesek, function(i, iname){
            if ($("[name='"+iname+"']").length > 0 && $("[name='"+iname+"']").val() != "")
            {
                var ar = +$("[name='"+iname+"']").data('ar'), klubar = +$("[name='"+iname+"']").data('klubar');

                total += ($("[name='"+iname+"']").val() * ar);
                klub_total += ($("[name='"+iname+"']").val() * klubar)
            }
        });*/

        $("[name^='kiszereles_']").each(function(i, kise){
            if ($(kise).length > 0 && $(kise).val() != "")
            {
                var ar = +$(kise).data('ar'), klubar = +$(kise).data('klubar');

                total += ($(kise).val() * ar);
                klub_total += ($(kise).val() * klubar);
            }
        });

        Kosar.itemtotal = total;

        console.log('2');
        $('[name="akt_termek_ar"]').val(total);
        $('[name="akt_termek_klub_ar"]').val(klub_total);

        if (
            $("html").prop('lang') == "de" ||
            $("html").prop('lang') == "en" ||
            $("html").prop('lang') == "sk" ||
            $("html").prop('lang') == "nl" ||
            $("html").prop('lang') == "fr"
        ){
            var precizitas = 2;
        }else{
            var precizitas = 0;
        }
        //$("span#kosarbanosszesen").text(this.formatNum(total))


        var value = '', value_klub = '', value_nagyker_brutto = '', value_afa = '';

        if ($("html").data('locale') == 'en_US' || $("html").data('locale') == 'en_UK' || $("html").data('locale') == 'en_AU')
        {
            value = curr + this.number_format(total,precizitas,".",",");
            value_klub = curr + this.number_format(klub_total,precizitas,".",",");

        } else if ($("html").data('locale') == 'hu_HU') {
            value = this.number_format(total,precizitas,"."," ") + ' ' + curr;
            value_klub = this.number_format(klub_total,precizitas,"."," ") + ' ' + curr;
        } else {
            value = this.number_format(total,precizitas,",",".") + ' ' + curr;
            value_klub = this.number_format(klub_total,precizitas,",",".") + ' ' + curr;

            value_afa = total * (afa / 100);
            value_nagyker_brutto = total + value_afa;

            value_afa =  this.number_format(value_afa,precizitas,",",".") + ' ' + curr;
            value_nagyker_brutto = this.number_format(value_nagyker_brutto,precizitas,",",".") + ' ' + curr;
        }

        $("span#kosarbanosszesen").text(value);
        if ($("span#kosarbanosszesen_klubar").length > 0)
        {
            $("span#kosarbanosszesen_klubar").text(value_klub);
        }

        if ($("span#kosarbanosszesen_afa").length > 0)
        {
            $("span#kosarbanosszesen_afa").text(value_afa);
            $("span#kosarbanosszesen_brutto").text(value_nagyker_brutto);
        }

    }

    synchronize()
    {
        setTimeout(function(){

            if (typeof shopKosarData != 'undefined')
            {
                if ($("html").data('locale') == 'hu_HU')
                {
                    /*
                    $.post('/kosar/sync', {data: shopKosarData, login: shopLoginStatus, logindata: shopLoginData, honaptermekei: shopAkciostermekekDataHu, honaptermeke_kedvezmeny: shopAkciostermekekKedvezmenyHu, aktloc: $("html").data('locale')}, function(res){
                        Kosar.syncCallback({'honaptermek': shopAkciostermekekKedvezmenyHu}, res);
                    });*/

                } else if ($("html").data('locale') == 'de_DE')
                {
                    /*
                    $.post('/kosar/sync', {data: shopKosarData, login: shopLoginStatus, logindata: shopLoginData, honaptermekei: shopAkciostermekekDataDe, honaptermeke_kedvezmeny: shopAkciostermekekKedvezmenyDe, aktloc: $("html").data('locale')}, function (res) {
                        Kosar.syncCallback({'honaptermek': shopAkciostermekekKedvezmenyDe}, res);
                    });*/
                } else if ($("html").data('locale') == 'en_US')
                {
                    $.post('/kosar/sync', {data: shopKosarData, login: shopLoginStatus, logindata: shopLoginData, honaptermekei: '', honaptermeke_kedvezmeny: '', aktloc: $("html").data('locale')}, function (res) {
                        Kosar.syncCallback({'honaptermek': ''}, res);
                    });
                } else if ($("html").data('locale') == 'en_AU')
                {
                    $.post('/kosar/sync', {data: shopKosarData, login: shopLoginStatus, logindata: shopLoginData, honaptermekei: shopAkciostermekekDataDe, honaptermeke_kedvezmeny: shopAkciostermekekKedvezmenyDe, aktloc: $("html").data('locale')}, function (res) {
                        Kosar.syncCallback({'honaptermek': shopAkciostermekekKedvezmenyDe}, res);
                    });
                }
            }
        }, 200);
    }

    syncCallback(datas, syncres) {

        if ($('.honap-termeke-inline').length > 0 && datas.honaptermek != '')
        {
            $('.honap-termeke-inline .val').text(datas.honaptermek);
        }

        window.siteLoginData = syncres.logindata;

        Kosar.updateFirmenArlabel();

    }

    updateFirmenArlabel()
    {

        if ($("html").data('locale') == 'de_DE')
        {
            try {

                if (typeof window.siteLoginData != "undefined")
                {
                    if (window.siteLoginData.is_reco === true)
                    {
                        $('.tplname-termekitemv4 .item .v4 .content .prices-kont .klub-label').each(function(){
                            var firmenText = $(this).data('firmen-label-text');
                            if (firmenText != "")
                            {
                                $(this).text(firmenText);
                            }
                        });
                    }
                }
            } catch(e) {}
        }

    }

    formatNum (strValue)
    {
        if (typeof(strValue) == 'number') {
            strValue = ('' + strValue).replace(/\./g,',');
        } else {
            strValue = '' + strValue;
        }
        var pattern=/^[0-9,\,\.]*$/;
        if(!pattern.test(strValue)) {
            return null;
        }
        var number = strValue.replace(/\./g,'');
        return number.toString().split('').reverse().join('').replace(/(?=\d*,?)(\d{3})/g,'$1 ').split('').reverse().join('').replace(/^[\.]/,'');
    }

    number_format(number, decimals, dec_point, thousands_sep) {
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    }

    // 12345678-2-22 ez a formátum a megfelelő
    adoszamInputCheck (inp) {
        let valid = false;

        if (!inp || typeof inp !== 'string') {
            return false;
        }

        inp = inp.trim();

        let parts;

        if (inp.includes('-')) {
            // 12345678-2-22
            parts = inp.split('-');
            if (parts.length !== 3) {console.log('f1 e1'); return false;};
        } else {
            // 12345678122
            if (inp.length !== 11) {console.log('f2 e1'); return false;};
            parts = [
                inp.substring(0, 8),
                inp.substring(8, 9),
                inp.substring(9)
            ];
        }

        const firstPart = parts[0];
        if (!/^\d{8}$/.test(firstPart)) {console.log('e2'); return false;};

        const middlePart = parseInt(parts[1]);
        if (!(middlePart >= 1 && middlePart <= 5)) {console.log('e3'); return false;};

        const countyCode = parseInt(parts[2]);
        const validCountyCodes = [
            ...Array.from({length: 20}, (_, i) => i + 1), // 01-20
            22, 23,
            ...Array.from({length: 14}, (_, i) => i + 31), // 31-44
            51
        ];

        if (validCountyCodes.includes(countyCode)) {
            valid = true;
        }

        return valid;
    }

}


export default Kosar;
